"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Turkish
var strings = {
  suffixAgo: 'önce',
  suffixFromNow: 'sonra',
  second: '1 saniye',
  seconds: '%d saniye',
  minute: '1 dakika',
  minutes: '%d dakika',
  hour: '1 saat',
  hours: '%d saat',
  day: '1 gün',
  days: '%d gün',
  month: '1 ay',
  months: '%d ay',
  year: '1 yıl',
  years: '%d yıl'
};
var _default = strings;
exports["default"] = _default;